// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3gK4r","content":"GlobalSearch_content__1DQl5"};